import { Box } from "@mui/material";
import CarLineDeskIcon from "@/assets/icons/hero/line-second-desk.svg?react";
import TruckDeskIcon from "@/assets/icons/hero/car-truck.svg?react";
import {
  secondaryLineIconStyles,
  secondaryIconWrapperStyles,
  secondaryCarIconStyles,
} from "./styles";

const SecondaryIcon = () => {
  return (
    <Box sx={secondaryIconWrapperStyles} mb={4}>
      <Box sx={secondaryLineIconStyles}>
        <CarLineDeskIcon />
      </Box>
      <Box sx={secondaryCarIconStyles}>
        <TruckDeskIcon width={77} height={73} />
      </Box>
    </Box>
  );
};

export default SecondaryIcon;
